import React from 'react';
import PropTypes from 'prop-types';
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import useLanguage from '../../../hooks/useLanguage';

import Star from '../../../svg/star_white.svg';
import FreeLessonModal from '../FreeLessonModal/FreeLessonModal';

const FreeLesson = ({ freeLessonData }) => {
  const langToggle = useLanguage;
  const { scroll } = useLocomotiveScroll();
  const [open, setOpen] = React.useState(false);
  function openModal() {
    setOpen(true);
    scroll.stop();
  }

  function closeModal() {
    setOpen(false);
    scroll.start();
  }

  return (
    <>
      <section className="free-lesson" data-scroll-section>
        <div className="content-wrapper">
          <div className="free-lesson__wrapper">
            <span className="home__free-lesson__title-wrapper">
              <h2 className="home__free-lesson__title">
                {langToggle(freeLessonData.title_ua, freeLessonData.title_ru)}
              </h2>
            </span>
            <div className="home__free-lesson__button-wrapper">
              <button className="home__free-lesson__button" onClick={openModal}>
                <Star className="home__free-lesson__button-star" />
                <span className="home__free-lesson__button-title__wrapper">
                  <span className="home__free-lesson__button-title">
                    {langToggle(
                      `Замовити \nбезкоштовне \nзаняття`,
                      `Получить \nбесплатный \nурок`
                    )}
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <FreeLessonModal
        open={open}
        closeModal={closeModal}
        title={langToggle(freeLessonData.title_ua, freeLessonData.title_ru)}
      />
    </>
  );
};

FreeLesson.propTypes = {
  freeLessonData: PropTypes.object,
};

export default FreeLesson;
